import React from 'react';
import Switch from '@material-ui/core/Switch';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Divider, Container, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        height: 180,
    },
    wrapper: {
        width: 100 + theme.spacing(2),
    },
    paper: {
        zIndex: 1,
        position: 'relative',
        margin: theme.spacing(1),
        padding: theme.spacing(5)
    },
    svg: {
        width: 100,
        height: 100,
    },
    polygon: {
        fill: theme.palette.common.white,
        stroke: theme.palette.divider,
        strokeWidth: 1,
    },
}));

export default function Mission({ parent }) {
    const classes = useStyles();
    const [checked, setChecked] = React.useState(false);
    const [elevation, setElevation] = React.useState(0);

    const handleChange = () => {
        setChecked((prev) => !prev);
    };
    React.useEffect(() => {
        window.scrollTo(0, 1);
    }, []);

    return (
        <section id="mission">
            <div className="features-bg1">
                <Container>
                    <div className="heading">
                        <Typography variant="h4" className="efecto-espejo">
                            Misión
                        </Typography>
                        {/* <h3>Santiago de Cuba</h3> */}
                    </div>
                    <Grid container spacing={1} direction="row"  justify="center"  alignItems="flex-start">
                        <Grid item sm={12} md={6} lg={7}>
                            <img src="./assets/frontend/onepage2/img/member/men22.png" style={{width: '100%'}}/>
                        </Grid>
                        <Grid item sm={12} md={6} lg={5}>
                            <Paper elevation={elevation} className={classes.paper} onMouseOver={() => setElevation(4)} onMouseOut={() => setElevation(0)}>
                                <Slide direction="right" in={parent} mountOnEnter unmountOnExit timeout={500}>
                                    <Typography paragraph align="justify">
                                        El Centro Meteorológico Provincial es la institución encargada de suministrar informacion meteorológica y climática autorizada, confiable y oportuna sobre el estado y
                                        comportamiento futuro de la atmósfera. Esta información está dirigida a velar por la seguridad de la vida humana y reducir las pérdidas de bienes materiales ante desastres
                                        naturales de origen meteorólogico, contribuyendo directamente al bienestar de la comunidad y al desarrollo sostenible.
                                    </Typography>
                                </Slide>
                                <Divider />
                            </Paper>
                        </Grid>
                    </Grid>
                    {/* <div className={classes.root} >
                        <div className={classes.wrapper}>
                            <FormControlLabel
                                control={<Switch checked={checked} onChange={handleChange} />}
                                label="Show"
                            />
                            <Slide direction="up" in={checked} mountOnEnter unmountOnExit timeout={500}>

                                <Paper elevation={elevation} className={classes.paper} onMouseOver={() => setElevation(10)} onMouseOut={() => setElevation(0)}>
                                    <svg className={classes.svg}>
                                        <polygon points="0,100 50,00, 100,100" className={classes.polygon} />
                                    </svg>
                                </Paper>

                            </Slide>
                        </div>
                    </div> */}
                </Container>
            </div>
        </section>
    );
}